module.exports = __webpack_public_path__ + "img/land_wanke.bec8a7a0.png";